import React from 'react'
import PropTypes from 'prop-types'
import { FileUploadForm, FileSelect } from 'containers'
import { Title } from 'components/atoms'
import { Modal } from 'components/molecules'
import { useToggle } from 'hooks'

const FileSelectModal = ({ isOpen, toggle, onSelect }) => {
  const [isOpenUpload, toggleUpload] = useToggle(false)

  const handleSelect = (selectedFile) => {
    onSelect(selectedFile)
    if (isOpenUpload) toggleUpload()
    if (isOpen) toggle()
  }

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <Modal.Top>
          <Title>
            Selecionar ficheiro
          </Title>
        </Modal.Top>
        <FileSelect onClickUpload={toggleUpload} onSelect={handleSelect} />
      </Modal>
      <Modal isOpen={isOpenUpload} toggle={toggleUpload}>
        <Modal.Top>
          <Title>
            Carregar ficheiro
          </Title>
        </Modal.Top>
        <FileUploadForm onSubmit={handleSelect} />
      </Modal>
    </>
  )
}

FileSelectModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  onSelect: PropTypes.func,
}

FileSelectModal.defaultProps = {
  toggle: () => null,
  isOpen: false,
  onSelect: () => null,
}

export default FileSelectModal
